import dayjs from 'dayjs';
import { RegisteredLectureStatus } from '#types/registeredLectures';

export const timeFormatter = (utcTime: string): string => {
  const timestamp = Date.parse(utcTime);
  const hours = Math.floor(timestamp / 3600000);
  const minutes = Math.floor((timestamp % 3600000) / 60000);

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}`;
};

export const getCoachCareer = (date?: string) => {
  return date ? new Date().getFullYear() - new Date(date).getFullYear() : 0;
};

export const dayPeriodTimeFormatter = (time: string) => {
  // 오전/오후 hh:mm
  dayjs.locale('ko');
  const date = dayjs(time);
  const meridiem = date.format('A');
  const hours = date.format('h');
  const minutes = date.format('mm');
  return meridiem + ' ' + hours + ':' + minutes;
};

export const getRegisteredLectureStatus = (
  date: string
): RegisteredLectureStatus => {
  return dayjs(date).isBefore(dayjs(), 'hour')
    ? 'COMPLETED'
    : dayjs(date).isSame(dayjs(), 'hour')
    ? 'ONGOING'
    : 'UPCOMING';
};
